import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AdminFormPage, saveErrorToast } from "@components/CatalogIndex";
import TextField from "@components/FormsV2/TextField/TextField";
import GenericToggle from "@components/FormsV2/GenericToggle/GenericToggle";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { useQuestionnaireMutations } from "../api";
// Reuse the survey form's left-justify rule for the Published toggle.
import "../SurveyForm/style.css";

const FORM_ID = "questionnaire-new-form";

export const New = (): JSX.Element => {
  const navigate = useNavigate();
  const { create } = useQuestionnaireMutations();
  const [name, setName] = useState("");
  const [published, setPublished] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState<{
    variant: "success" | "danger";
    text: string;
  } | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      const result: any = await create({ name, published });
      const newId = result?.data?.id;
      navigate(newId ? `../${newId}/edit` : "..", {
        relative: "path",
        state: { toast: { variant: "success", text: `'${name}' saved` } },
      });
    } catch (err) {
      console.error("Failed to create questionnaire", err);
      setToast(saveErrorToast(err, "questionnaire"));
      setSubmitting(false);
    }
  };

  return (
    <>
      <AdminFormPage
        title="Add a Questionnaire"
        formId={FORM_ID}
        onCancel={() => navigate("..")}
        isSubmitting={submitting}
      >
        <Form
          id={FORM_ID}
          data-testid={FORM_ID}
          className="survey-form"
          onSubmit={handleSubmit}
        >
          <div className="row">
            <div className="col-sm-6">
              <Form.Label htmlFor="questionnaire-new-name">Name</Form.Label>
              <TextField
                label={null}
                id="questionnaire-new-name"
                value={name}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setName(e.target.value)
                }
                required
              />
            </div>
            <div className="col-sm-6">
              <Form.Label>Published?</Form.Label>
              <div className="survey-form__toggle">
                <GenericToggle
                  initialValueOfIsOn={published}
                  onToggle={setPublished}
                  onText="Published"
                  offText="Draft"
                  hasText
                />
              </div>
            </div>
          </div>
        </Form>
      </AdminFormPage>
      {toast && (
        <ToastAlert
          variant={toast.variant}
          text={toast.text}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default New;
